import { z } from 'zod/v4'

export const KanbanConfigSchema = z.object({
  statusBadgeField: z.string().optional(),
  descriptionField: z.string().optional(),
})

export type KanbanConfig = z.infer<typeof KanbanConfigSchema>
